<template>
  <section class="box">
    <div :class="[ShowTitle ? 'mt-15' : '']" class="carousel-wrapper">
      <h2 v-if="ShowTitle">מוצרים חמים</h2>
      <Carousel
        :pauseAutoplayOnHover="true"
        :wrap-around="true"
        :breakpoints="breakpoints"
        :autoplay="5000"
        :dir="'rtl'"
      >
        <Slide v-for="(product, index) in products" :key="product.part">
          <productItem
            dir="rtl"
            :product="product"
            :TheCounter="product.quant"
            :auth-status="isAuthenticated"
            :priceListId="priceListId"
            @click="navigateToProduct(index)"
            @updateProduct="updateProduct"
          />
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </section>
</template>

<script>
import productItem from "../productItem.vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default {
  emits: ["updateProduct"],
  components: {
    productItem,
    Carousel,
    Slide,
    // Pagination,
    Navigation,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    breakpoints: {
      type: Object,
    },
    ShowTitle: {
      type: Boolean,
      default: false,
    },
    isAuthenticated: {
      type: Boolean,
    },
    priceListId: {
      type: String,
    },
  },
  data() {
    return {
      model: null,
    };
  },
  methods: {
    navigateToProduct(index) {
      const product = this.products[index];

      if (this.$route.name === "CategoryProducts") {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            productId: product.part,
          },
        });
        return;
      }

      this.$router.push({
        path: `/products/${product.part}`,
      });
    },
    updatePartRquestAddToPriceList(partId) {
      this.$emit("updatePartRquestAddToPriceList", partId);
    },
    updateProduct(updObj) {
      this.$emit("updateProduct", updObj);
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.carousel__slide div:first-child) {
  width: 99% !important;
}
// :deep(.carousel__track) {
//   gap: 20px !important;
// }
// .carousel__slide {
//   width: auto !important;
//   padding: 0 !important;
// }
// .carousel-wrapper {
//   padding: 20px;

//   :deep(.carousel__slide) {
//     padding: 0 8px;
//   }

//   :deep(.carousel__pagination) {
//     margin-top: 20px;
//   }

//   :deep(.carousel__prev),
//   :deep(.carousel__next) {
//     background-color: rgba(201, 199, 199, 0.52);
//     border-radius: 50%;
//     width: 32px;
//     height: 32px;

//     &:hover {
//       background-color: rgba(0, 0, 0, 0.308);
//     }
//   }
// }
h2 {
  text-align: center;
  font-family: Heebo;
  font-size: 35px;
  font-weight: 300;
  margin-bottom: 40px;
}
.isTablet,
.isMobile {
  .carousel-wrapper {
    padding: 5px !important;
  }
}
</style>
